<div class="modal-header align-items-center">
  <div class="col">
    <h4 class="modal-title">
      <span [ngClass]="iconClass" class="mr-1"></span>
      <span [innerHTML]="menuItem.name"></span>
    </h4>
  </div>
  <div class="col-auto">
    <button (click)="onClose()" aria-label="Close" class="close" type="button">
      <span aria-hidden="true" class="fa-solid fa-xmark"></span>
    </button>
  </div>
</div>
<div class="modal-body">
  <div class="row align-items-center mb-1 section-fixed">
    <div class="col">
      <h3 class="h6 mb-0" [innerText]="sharedMenuItems"></h3>
    </div>
    <div class="col-auto">
      @if (!isMachineGroup) {
        <small class="text-muted" translate>Can only be modified by Admins.</small>
      }
      @if (isMachineGroup) {
        <small class="text-muted" translate>Can only be modified by Tech Admins or higher.</small>
      }
    </div>
  </div>

  <scitis-list-menu-items (baseMenuItemsOrderChanged)="onBaseMenuItemsOrderChanged($event)"
    (propertiesFallback)="setPropertiesFallback($event)"
    (nodeItemEdit)="onUpdateNode($event)"
    (pageItemDelete)="onDeletePageItem($event)"
    (pageItemEdit)="onEditPageItem($event)"
    (pagesInsideNode)="onGetPagesInsideNode($event)"
    (sharePageItem)="onSharePageItem($event)"
    (sharePageItemInsideNode)="onSharePageItemInsideNode($event)"
    (editPageItemInsideNode)="onEditPageItemInsideNode($event)"
    (unsharePageItem)="onUnsharePageItem($event)"
    (updatedItemsInsideNode)="onItemsInsideNodeChanged($event)"
    (userMenuItemsOrderChanged)="onUserMenuItemsOrderChanged($event)"
    (disableSaveButton)="onDisableSaveButton($event)"
    (pageFormIsActive)="onDeactivateAddForms()"
    [baseMenuItems]="baseMenuItems"
    [dragAndDropEnabledForBaseMenuItems]="dragAndDropEnabledForBaseMenuItems"
    [isAdminOrHigher]="isAdminOrHigher"
    [isHigherThanAdmin]="isHigherThanAdmin"
    [menuItemType]="menuItem.type"
    [pageTypeOptions]="pageTypeOptions"
    [userMenuItems]="userMenuItems"
    [refreshNodes]="refreshNodes"
    [addFormIsActive]="addFormIsActive"
    [allPagesInsideNode]="allPagesInsideNode"
    [pageItemsToBeDeleted]="pageItemsToBeDeleted">
  </scitis-list-menu-items>

  <ul class="list-group mb-2">

    <!-- Inline page form -->
    @if (addNewPage) {
      <li class="list-group-item edit-menu-item">
        <scitis-edit-page-inline-form
          (newPageCancel)="onCancelSavePage()"
          (newPageSave)="onSaveNewPage($event)"
          [allPagesInsideNode]="allPagesInsideNode"
          [baseMenuItems]="baseMenuItems"
          [machineId]="menuItem.machineId"
          [userMenuItems]="userMenuItems"
          [pageTypeOptions]="pageTypeOptions"
          [pageItemsToBeDeleted]="pageItemsToBeDeleted">
        </scitis-edit-page-inline-form>
      </li>
    }

    <!-- Inline node form -->
    @if (addNewNode) {
      <li class="list-group-item edit-menu-item">
        <scitis-edit-node-inline-form
          (newNodeCancel)="onCancelSaveNode()"
          (newNodeSave)="onSaveNode($event)"
          [userMenuItems]="originalUserMenuItems"
          >
        </scitis-edit-node-inline-form>
      </li>
    }
  </ul>

  @if (displayAddPageButton) {
    <button (click)="onAddPage()" class="btn btn-outline-primary mr-2">
      <span class="fa-solid fa-plus"></span>
      <span translate>Add page</span>
    </button>
  }
  @if (menuItem.isMachine && nodeFunctionalityEnabled) {
    <button (click)="onAddNode()" class="btn btn-outline-primary">
      <span class="fa-solid fa-folder-plus"></span>
      <span translate>Add node</span>
    </button>
  }
</div>
@if (isDeletionInProgress) {
  <div class="col mb-2">
    <span translate> Deletion is in progress...</span>
    <span class="fa-solid fa-spinner fa-spin ml-2"></span>
  </div>
}
<div class="modal-footer">
  <div class="modal-footer-inner">
    <div class="row align-items-center flex-fill">
      <div class="col">
        @if (addFormIsActive) {
          <scitis-required-field-indicator-explanation>
          </scitis-required-field-indicator-explanation>
        }
      </div>
      <div class="col-auto">
        <button (click)="onCancel()"
          class="btn btn-outline-primary mr-2"
          translate type="button">Cancel
        </button>
        <button (click)="onSave()" [disabled]="getSaveButtonDisabled()"
          class="btn btn-primary"
          translate type="button">Save
        </button>
      </div>
    </div>
  </div>
</div>
